import dynamic from '@/utils/dynamic';

const EmojiPicker = dynamic(
  () =>
    import(
      /* webpackChunkName: "emoji-picker" */
      './EmojiPicker'
    ),
);

export default EmojiPicker;
